import React, { useContext, useEffect, useState } from 'react'
import { SignUp } from '../Api/SignUp';
import { SignIn } from '../Api/SignIn';
import { useNavigate } from 'react-router-dom';
import LoginPageCss from '../css/LoginPageCss';
import { Flip, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Context } from '../Context/Context';
import { Helmet } from 'react-helmet';
import { ResetPassword } from "../Api/ResetPassword";

export default function Login() {
    const [showResetPassword, setShowResetPassword] = useState(false);
    const { setWallet, setLoad, setLoadColor } = useContext(Context);
    const [resetPasswordData, setResetPasswordData] = useState({
        username: "",
        password: "",
        confirmPassword: ""
    });
    const navigate = useNavigate();

    useEffect(() => {
        const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;
        if (auth_token) {
            navigate('/game');
        }
    }, [navigate])

    const [signUpIn, setSignUpIn] = useState(false)
    const [signUpData, setSignUpData] = useState({
        name: "",
        username: "",
        password: "",
        phone: "",
    })
    const [signInData, setSignInData] = useState({
        username: "",
        password: "",
    })
    const handleResetPasswordChange = (e, field) => {
        setResetPasswordData((prev) => ({
            ...prev,
            [field]: e.target.value
        }));
    };
    const handleChangeSignUp = (e, value) => {
        if (value === "name") {
            setSignUpData((prevData) => ({
                ...prevData,
                name: e.target.value,
            }));
        }
        else if (value === "username") {
            setSignUpData((prevData) => ({
                ...prevData,
                username: e.target.value,
            }));
        }
        else if (value === "password") {
            setSignUpData((prevData) => ({
                ...prevData,
                password: e.target.value,
            }));
        }
        else if (value === "mobile") {
            setSignUpData((prevData) => ({
                ...prevData,
                phone: e.target.value,
            }));
        }
    };
    const handleChangeSignIn = (e, value) => {
        if (value === "username") {
            setSignInData((prevData) => ({
                ...prevData,
                username: e.target.value,
            }));
        }
        else if (value === "password") {
            setSignInData((prevData) => ({
                ...prevData,
                password: e.target.value,
            }));
        }
    };

    const handleResetPassword = async () => {

        if (
            resetPasswordData.username === "" ||
            resetPasswordData.password === "" ||
            resetPasswordData.confirmPassword === ""
        ) {
            toast.error("Please fill all fields.");
            return;
        }

        if (
            resetPasswordData.password !==
            resetPasswordData.confirmPassword
        ) {
            toast.error("Passwords do not match.");
            return;
        }

        setLoad(true);
        setLoadColor("#ff4364");

        const res = await ResetPassword({
            username: resetPasswordData.username,
            password: resetPasswordData.password
        });

        setLoad(false);

        if (res?.data?.status) {

            toast.success("Password reset successfully.");

            setShowResetPassword(false);

            setResetPasswordData({
                username: "",
                password: "",
                confirmPassword: ""
            });

        } else {

            toast.error(res?.data?.message);

        }
    };

    const handleClickSignUpUser = async (e) => {
        e.preventDefault();
        if (signUpData.name !== "" && signUpData.username !== "" && signUpData.password && signUpData?.phone?.length === 10) {
            setLoad(true);
            setLoadColor("#ff4364")
            let res = await SignUp(signUpData)
            console.log(res)
            if (res) {
                if (res.data.status) {
                    localStorage.setItem("userinfo", JSON.stringify(res.data.data));
                    setWallet(res.data.data.wallet);
                    navigate("/game")
                    toast.success('User Registered Successfully', {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        transition: Flip,
                    });
                    setSignUpData((prevData) => ({
                        ...prevData,
                        name: "",
                        username: "",
                        password: "",
                        phone: "",
                    }));
                }
                else {
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        transition: Flip,
                    });
                }
            }
            setLoad(false);
        }
        else if (signUpData.name !== "" && signUpData.username !== "" && signUpData.password && signUpData?.phone?.length !== 10) {
            toast.warn('Give Correct Number', {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
        else {
            toast.error("Give all Details Properly", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }

    const handleClickSignInUser = async (e) => {
        e.preventDefault();
        if (signInData.username !== "" && signInData.password !== "") {
            setLoad(true);
            setLoadColor("#ff4364")
            console.log(signInData)
            let res = await SignIn(signInData);
            console.log(res);
            if (res) {
                if (res.data.status) {
                    localStorage.setItem("userinfo", JSON.stringify(res.data.data));
                    setWallet(res.data.data.wallet);
                    toast.success('User Login Successfully', {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        transition: Flip,
                    });
                    navigate("/game")
                    setSignInData((prevData) => ({
                        ...prevData,
                        username: "",
                        password: "",
                    }));
                }
                else {
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        transition: Flip,
                    });
                }
                setLoad(false);
            }
            setLoad(false);
        }
        else {
            toast.error("Give all Details Properly", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            });
        }
    }

    const handleChangeLoginMethod = () => {
        setSignUpIn(!signUpIn)
        setSignInData((prevData) => ({
            ...prevData,
            username: "",
            password: "",
        }));
        setSignUpData((prevData) => ({
            ...prevData,
            name: "",
            username: "",
            password: "",
            phone: "",
        }));
    }

    return (
        <>
            <LoginPageCss>
                {/* <Helmet>
                    <title>Login Page</title>
                    <meta name="LoginPageLandscape" content="This Page is for login in to the Matka Jantri apk with potrate view " />
                </Helmet> */}

                <Helmet>
                    <title>Matka Jantri | India’s Trusted Online Jantri Calculator & Record Maintainer for Matka Games</title>

                    <meta
                        name="description"
                        content="Use Matka Jantri – India’s trusted online jantri calculator and matka record maintainer. APK for accurate and fast results. Easy to use on mobile and web."
                    />
                    <meta
                        name="keywords"
                        content="jantri, Matka Jantri, jantri calculator, matka games, jantri apk, record maintainer matka, satta matka jantri, jod calculator"
                    />
                    <meta name="author" content="Matka Jantri Team (Miraj Sport's)" />

                    <meta property="og:title" content="Matka Jantri | Online Jantri Calculator for Matka Games" />
                    <meta
                        property="og:description"
                        content="Free jantri calculator and record maintainer APK for matka games. Try Matka Jantri online – fast, accurate and easy to use."
                    />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://app.matkajantri.com" />
                    <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                    <meta name="google-site-verification" content="d6d81656210c6db7" />

                    <link rel="canonical" href="https://app.matkajantri.com" />

                    {/* Favicon and icons */}
                    <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                    <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
                </Helmet>



                <div className={`container Login ${signUpIn ? "right-panel-active" : ""}`} id="container">
                    <div className="form-container sign-up-container">
                        <form action="#">
                            <h1>Create Account</h1>
                            {/*<div className="social-container">
                                <a href="#" className="social">
                                    <i className="fab fa-facebook-f" />
                                </a>
                                <a href="#" className="social">
                                    <i className="fab fa-google-plus-g" />
                                </a>
                                <a href="#" className="social">
                                    <i className="fab fa-linkedin-in" />
                                </a>
                            </div>*/}
                            <span>or use your email for registration</span>
                            <input type="name" placeholder="Name" value={signUpData.name} onChange={(e) => { handleChangeSignUp(e, "name") }} required />
                            <input type="username" placeholder="Username" value={signUpData.username} onChange={(e) => { handleChangeSignUp(e, "username") }} required />
                            <input type="password" placeholder="Password" value={signUpData.password} onChange={(e) => { handleChangeSignUp(e, "password") }} required />
                            <input type="tel" placeholder="Mobile No." value={signUpData.phone} onChange={(e) => { (e.target.value === '' || /^\d+$/.test(e.target.value)) && e.target.value.length < 11 && handleChangeSignUp(e, "mobile") }} required />
                            <button onClick={(e) => handleClickSignUpUser(e)}>Sign Up</button>
                        </form>
                    </div>
                    <div className="form-container sign-in-container">
                        <form >
                            <h1>Sign in</h1>
                            {/*<div className="social-container">
                                <a href="#" className="social">
                                    <i className="fab fa-facebook-f" />
                                </a>
                                <a href="#" className="social">
                                    <i className="fab fa-google-plus-g" />
                                </a>
                                <a href="#" className="social">
                                    <i className="fab fa-linkedin-in" />
                                </a>
                            </div>*/}
                            <span>to use your account</span>
                            <input type="Username" value={signInData.username} onChange={(e) => { handleChangeSignIn(e, "username") }} placeholder="Username" required />
                            <input
                                type="password"
                                value={signInData.password}
                                onChange={(e) => { handleChangeSignIn(e, "password") }}
                                placeholder="Password"
                                required
                            />

                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShowResetPassword(true);
                                }}
                                style={{
                                    alignSelf: "flex-end",
                                    margin: "8px 0 15px",
                                    fontSize: "13px",
                                    color: "#ff4364",
                                    textDecoration: "none",
                                    cursor: "pointer"
                                }}
                            >
                                Forgot Password?
                            </a>

                            <button onClick={(e) => handleClickSignInUser(e)}>
                                Sign In
                            </button>
                        </form>

                    </div>
                    <div className="overlay-container">
                        <div className="overlay">
                            <div className="overlay-panel overlay-left">
                                <h1>Welcome Back!</h1>
                                <p>To keep connected with us please login with your personal info</p>
                                <button className="ghost" id="signIn" onClick={() => handleChangeLoginMethod()}>
                                    Sign In
                                </button>
                            </div>
                            <div className="overlay-panel overlay-right">
                                <h1>Hello, Friend!</h1>
                                <p>Enter your personal details and start journey with us</p>
                                <button className="ghost" id="signUp" onClick={() => handleChangeLoginMethod()}>
                                    Sign Up
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {showResetPassword && (
                    <div className="reset-password-overlay">
                        <div className="reset-password-modal">

                            <div className="reset-header">
                                <h2>Reset Password</h2>
                                <button
                                    className="close-btn"
                                    onClick={() => {
                                        setShowResetPassword(false);

                                        setResetPasswordData({
                                            username: "",
                                            password: "",
                                            confirmPassword: ""
                                        });
                                    }}
                                >
                                    ✕
                                </button>
                            </div>

                            <p className="reset-subtitle">
                                Enter your username and choose a new password.
                                Password reset will only work from a previously used network.
                            </p>

                            <input
                                type="text"
                                placeholder="Username"
                                value={resetPasswordData.username}
                                onChange={(e) => handleResetPasswordChange(e, "username")}
                            />

                            <input
                                type="password"
                                placeholder="New Password"
                                value={resetPasswordData.password}
                                onChange={(e) => handleResetPasswordChange(e, "password")}
                            />

                            <input
                                type="password"
                                placeholder="Confirm Password"
                                value={resetPasswordData.confirmPassword}
                                onChange={(e) => handleResetPasswordChange(e, "confirmPassword")}
                            />

                            <button
                                type="button"
                                className="reset-btn"
                                onClick={handleResetPassword}
                            >
                                Reset Password
                            </button>

                        </div>
                    </div>
                )}
            </LoginPageCss>
        </>
    )
}
